import axios from '@/libs/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libs/react-query';
import { useQuery } from '@tanstack/react-query'; //
import { User } from '@/types'; //

interface Response {
  data: User;
}

//
const request = (): Promise<Response> => {
  return axios.post('info');
};

type QueryFnType = typeof request;
//
type UseDetailOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useUserInfo = ({ config }: UseDetailOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['user-info'],
    queryFn: () => request(),
  });
};
